import { initializeYup } from "@duosoftbg/nacid-components";
import * as yup from "yup";
import i18n from "i18next";

export const createAdditionalDocDetailsValidationSchemas = () => {
  initializeYup(yup);

  const additionalDocDetailsValidationSchemas = yup.object({
    entryNumber: yup.string().required().max(100, i18n.t("validation.charCount.invalid.100")),
    additionalInfo: yup.string().nullable().max(500, i18n.t("validation.charCount.invalid.500")),
  });

  return additionalDocDetailsValidationSchemas;
};
